/* Scentology — sale countdown (announcement bar) */
(function () {
  'use strict';

  if (window.__scSaleCountdown) return;
  window.__scSaleCountdown = true;

  var wired = typeof WeakSet === 'function' ? new WeakSet() : null;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function wire(el) {
    if (wired) {
      if (wired.has(el)) return;
      wired.add(el);
    }

    var end = Date.parse(el.getAttribute('data-countdown-end') || '');
    if (isNaN(end)) {
      el.hidden = true;
      return;
    }

    var daysSeg = el.querySelector('[data-seg="days"]');
    var parts = {
      days: el.querySelector('[data-part="days"]'),
      hours: el.querySelector('[data-part="hours"]'),
      minutes: el.querySelector('[data-part="minutes"]'),
      seconds: el.querySelector('[data-part="seconds"]')
    };
    var timer;

    function tick() {
      var remaining = end - Date.now();
      if (remaining <= 0) {
        clearInterval(timer);
        el.hidden = true;
        return;
      }
      var total = Math.floor(remaining / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      if (daysSeg) daysSeg.hidden = d === 0;
      setText(parts.days, pad(d));
      setText(parts.hours, pad(h));
      setText(parts.minutes, pad(m));
      setText(parts.seconds, pad(s));
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function init(root) {
    var els = (root || document).querySelectorAll('[data-sale-countdown]');
    Array.prototype.forEach.call(els, wire);
  }

  init();

  /* Theme editor re-renders sections in place; pick up the fresh markup. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
